import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";

import CreateIcon from "@material-ui/icons/Create";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import { IManagementStore } from "Stores/Management/types";
import { Values } from "Tools/Values";
import PermissionGroupForm from "@src/Components/Pages/Main/Content/PermissionGroups/PermissionGroupForm/PermissionGroupForm";
import { PermissionGroup } from "@src/Interfaces/Entity/PermissionGroup";
import {IAuthStore} from "Stores/Auth/types";
import {IValuesStore} from "Stores/Values/types";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  management?: IManagementStore;
  auth?: IAuthStore;
  values?: IValuesStore;
  permissionGroup: PermissionGroup;
}

@inject("management", "auth", "values")
@observer
export default class PermissionGroupEdit extends React.Component<IProps> {
  @observable editOpened: boolean = false;

  handleOpenEdit = () => {
    this.editOpened = true;
  };
  handleCloseEdit = () => {
    this.editOpened = false;
  };

  handleUpdate = async (values: PermissionGroup) => {
    // The code below is used to inject Admin permission ID if that was removed by user without admin permissions
    // because it is hard to intercept TransferList both with Formik to disable possibility to move single item
    const adminPermissionId = this.props.values.common["AdminPermissionId"];
    if (!this.props.auth.isAdmin) {
      if (this.props.permissionGroup.permissions.includes(adminPermissionId)) {
        if (!values.permissions.includes(adminPermissionId)) {
          values.permissions = [ adminPermissionId, ...values.permissions];
        }
      }
    }
    
    await this.props.management.savePermissionGroup(values);
    this.editOpened = false;
  };

  render() {
    return (
      <React.Fragment>
        <RoundButton
            icon={<CreateIcon/>}
            tooltipTitle={Values.getLocalizationValue("edit")}
            onClick={() => this.handleOpenEdit()}
        />
        
        <SimpleModal width={710} isOpened={this.editOpened} onClose={this.handleCloseEdit}>
          <PermissionGroupForm
            title={Values.getLocalizationValue("edit")}
            initialValues={this.props.permissionGroup}
            onSubmit={this.handleUpdate}
            onClose={this.handleCloseEdit}
          />
        </SimpleModal>
      </React.Fragment>
    );
  }
}
